module.exports = __webpack_public_path__ + "static/img/logo_ncpc.676b1f59.png";